/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ActiveFeedbackForm,
  IndicatorFeedbackResponse,
  IndicatorFeedbackWriteRequest,
  IndicatorKindOption,
  IndicatorsByMemberListParams,
  PaginatedMemberIndicatorGroupList
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * POST /api/v2/indicators/:id/feedback - append a form-driven response.
 *
 * Append-only: a resubmit supersedes the reviewer's prior active response rather
 * than editing it, so there is no PUT/DELETE. Attribution is taken from auth, and
 * an indicator whose member the requester can't see reads as 404 (never leak it).
 * @summary Submit indicator feedback (append-only, supersedes prior)
 */
export const indicatorsFeedbackCreate = (
    id: string,
    indicatorFeedbackWriteRequest: IndicatorFeedbackWriteRequest,
 options?: SecondParameter<typeof apiV2<IndicatorFeedbackResponse>>,) => {
      return apiV2<IndicatorFeedbackResponse>(
      {url: `/indicators/${id}/feedback/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: indicatorFeedbackWriteRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 * @summary Member-grouped indicator inbox (cursor-paginated)
 */
export const indicatorsByMemberList = (
    params?: IndicatorsByMemberListParams,
 options?: SecondParameter<typeof apiV2<PaginatedMemberIndicatorGroupList>>,) => {
      return apiV2<PaginatedMemberIndicatorGroupList>(
      {url: `/indicators/by-member/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * GET /api/v2/indicators/feedback-form - the one active form, or 404.
 *
 * A singleton, not a collection: the ``one_active_feedback_form`` partial unique
 * index guarantees at most one active row, so this returns a single object and
 * 404s (never 200 with a null body) when no form is deployed.
 * @summary The single active indicator feedback form
 */
export const indicatorsFeedbackFormList = (

 options?: SecondParameter<typeof apiV2<ActiveFeedbackForm[]>>,) => {
      return apiV2<ActiveFeedbackForm[]>(
      {url: `/indicators/feedback-form/`, method: 'GET'
    },
      options);
    }
  /**
 * GET /api/v2/indicators/kinds - enabled, producible kinds with human labels.
 *
 * Sources the FE signal-kind filter dropdown. Not paginated (a small fixed set) and
 * not DB-backed alone: the human label lives on the producer, not the IndicatorKind row.
 * @summary Selectable indicator kinds for the by-member filter
 */
export const indicatorsKindsList = (

 options?: SecondParameter<typeof apiV2<IndicatorKindOption[]>>,) => {
      return apiV2<IndicatorKindOption[]>(
      {url: `/indicators/kinds/`, method: 'GET'
    },
      options);
    }
  export type IndicatorsFeedbackCreateResult = NonNullable<Awaited<ReturnType<typeof indicatorsFeedbackCreate>>>
export type IndicatorsByMemberListResult = NonNullable<Awaited<ReturnType<typeof indicatorsByMemberList>>>
export type IndicatorsFeedbackFormListResult = NonNullable<Awaited<ReturnType<typeof indicatorsFeedbackFormList>>>
export type IndicatorsKindsListResult = NonNullable<Awaited<ReturnType<typeof indicatorsKindsList>>>
